import { Component, computed, input, linkedSignal, model, output } from '@angular/core';
import { form, FormField, FormValueControl } from '@angular/forms/signals';
import { NgIcon } from '@ng-icons/core';
import { CalendarInput } from '../calendar-input/calendar-input';
import { NgClass } from '@angular/common';
import { DebounceDirective } from '../../directives/debounce.directive';
import { format, parse } from 'date-fns';
import { DateInputRegExp } from './definitions';
import { PopoverComponent } from '../popover/popover';
import { PopoverDirective } from '../../directives/popover-directive';
import { toDateString } from '../calendar-range-input/definitions';
import { Button } from '../button/button';
import { DateString } from '../calendar-input/definitions';

@Component({
  selector: 'ui-date-input',
  imports: [
    NgIcon,
    PopoverComponent,
    CalendarInput,
    PopoverDirective,
    FormField,
    NgClass,
    DebounceDirective,
    Button,
  ],
  templateUrl: './date-input.html',
})
export class DateInput implements FormValueControl<DateString | null> {
  inputId = input<string | null>(null);
  placeholder = input<string>('');
  autocomplete = input<string>('off');

  fieldValueChange = output<DateString | null>();

  readonly value = model<DateString | null>(null);
  readonly disabled = input<boolean>(false);
  readonly touched = model<boolean>(false);

  readonly debounceMs = input<number | null>(null);

  protected displayValue = linkedSignal(() => {
    const date = this.model().date;
    if (date === null) {
      return null;
    }
    return format(date, 'dd.MM.yyyy');
  });

  private model = linkedSignal(() => ({
    date: this.value(),
  }));
  protected form = form(this.model);

  protected showClearButton = computed(() => this.value() !== null && !this.disabled());

  protected onChangeCalendarValue(value: DateString | null) {
    this.touched.set(true);
    this.value.set(value);
    this.fieldValueChange.emit(value);
  }

  protected onChangeInputValue(value: string | null) {
    if (value === '' || value === null) {
      this.value.set(null);
      this.fieldValueChange.emit(null);
      return;
    }
    if (!value.match(DateInputRegExp)) {
      return;
    }
    const date = toDateString(parse(value, 'dd.MM.yyyy', new Date()));
    this.value.set(date);
    this.fieldValueChange.emit(date);
  }

  protected onInputFocus(popover: PopoverComponent) {
    this.touched.set(true);
    popover.show();
  }

  protected onClickClear() {
    this.touched.set(true);
    this.value.set(null);
    this.fieldValueChange.emit(null);
  }
}
